module.exports = __webpack_public_path__ + "static/media/fall.950dda3b.png";